import { UserSingleIcon } from '@calendly/ui/components/icons'
import { DetailsItem as Item } from '@calendly/booking-kit'

export default ({ name }) => (
  <Item>
    <UserSingleIcon size="large" spacingRight={8} data-id="details-item-icon" />
    {name}
  </Item>
)
